import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=68ce3f1e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ce3f1e')) {
      api.createRecord('68ce3f1e', component.options)
    } else {
      api.reload('68ce3f1e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=68ce3f1e&", function () {
      api.rerender('68ce3f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29qOre4QYjwDy/JS/comp/childrenage.vue"
export default component.exports